import productStoreMutations from './productStore/productStoreMutations'
import productStoreActions from './productStore/productStoreActions'
import getProductStoreDefaultState from './productStore/productStoreDefaultState'

let state = getProductStoreDefaultState()

export const productStore = {
  namespaced: true,
  state,
  mutations: productStoreMutations,
  actions: productStoreActions
}
